import { motion } from "framer-motion";

interface Props {
  children: JSX.Element;
}

const MotionContainer = (props: Props): JSX.Element => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1, height: "100%" }}
      viewport={{ once: true }}
    >
      {props.children}
    </motion.div>
  );
};
export default MotionContainer;
